import UserCardSubInfoBlock from './UserCardSubInfoBlock';

export default UserCardSubInfoBlock;
